<script>
  import { browser } from "../../stores";
  import SectorPreview from "./SectorPreview.svelte";
  import ViewAllCard from "./ViewAllCard.svelte";

  //props
  export let sectors;
  export let mode = "standard";

  //ie hacks
  const isIE = browser.name === "ie";
</script>

{#if mode === "standard"}
  <div class="sectors-preview-grid {isIE ? 'ie' : ''}">
    {#each sectors as sector}
      <SectorPreview {sector} />
    {/each}
  </div>
{/if}

{#if mode === "browse"}
  <div class="sectors-preview-grid {isIE ? 'ie' : ''}">
    {#each sectors as sector}
      <SectorPreview {sector} browse />
    {/each}
  </div>
{/if}

{#if mode === "explore"}
  <div class="sectors-preview-grid four-col {isIE ? 'ie' : ''}">
    {#each sectors as sector, i}
      {#if i + 1 <= 3}
        <SectorPreview {sector} small />
      {/if}
    {/each}
    <ViewAllCard />
  </div>
{/if}

<style>
  .sectors-preview-grid {
    display: grid;
    grid-gap: 48px;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 60px 0;
  }
  .four-col {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    padding-top: 60px;
  }
  @media screen and (max-width: 1200px) {
    .four-col {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media screen and (max-width: 964px) {
    .sectors-preview-grid,
    .four-col {
      grid-template-columns: 1fr 1fr;
      grid-gap: 30px;
    }
  }
  @media screen and (max-width: 640px) {
    .sectors-preview-grid,
    .four-col {
      grid-template-columns: 1fr;
      max-width: 420px;
      margin: 0 auto;
    }
  }
  @media screen and (max-width: 580px) {
    .sectors-preview-grid {
      padding-top: 40px;
    }
  }

  .ie {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 0;
    margin: -24px;
  }
  .ie :global(a.sector-preview) {
    margin: 24px;
    width: calc((100% - 144px) / 3);
  }

  .four-col.ie :global(a.sector-preview) {
    width: calc((100% - 192px) / 4);
  }

  @media screen and (max-width: 1200px) {
    .four-col.ie :global(a.sector-preview) {
      width: calc((100% - 144px) / 3);
    }
  }

  @media screen and (max-width: 964px) {
    .ie {
      margin: -15px;
    }
    .ie :global(a.sector-preview),
    .four-col.ie :global(a.sector-preview) {
      margin: 15px;
      width: calc((100% - 60px) / 2);
    }
  }
  @media screen and (max-width: 640px) {
    .ie,
    .four-col.ie {
      max-width: 420px;
      margin: 0 auto;
    }
    .ie :global(a.sector-preview),
    .four-col.ie :global(a.sector-preview) {
      margin: 0 0 30px;
      width: 100%;
    }
  }
</style>
